var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00001 4.99995V1.00195C7.00001 0.736737 6.89466 0.482383 6.70712 0.294847C6.51958 0.10731 6.26523 0.00195312 6.00001 0.00195312C5.7348 0.00195312 5.48044 0.10731 5.29291 0.294847C5.10537 0.482383 5.00001 0.736737 5.00001 1.00195V4.99995H1.00201C0.736798 4.99995 0.482444 5.10531 0.294908 5.29285C0.107371 5.48038 0.00201416 5.73474 0.00201416 5.99995C0.00201416 6.26517 0.107371 6.51952 0.294908 6.70706C0.482444 6.8946 0.736798 6.99995 1.00201 6.99995H5.00001V10.998C5.00001 11.2632 5.10537 11.5175 5.29291 11.7051C5.48044 11.8926 5.7348 11.998 6.00001 11.998C6.26523 11.998 6.51958 11.8926 6.70712 11.7051C6.89466 11.5175 7.00001 11.2632 7.00001 10.998V6.99995H10.998C11.2632 6.99995 11.5176 6.8946 11.7051 6.70706C11.8927 6.51952 11.998 6.26517 11.998 5.99995C11.998 5.73474 11.8927 5.48038 11.7051 5.29285C11.5176 5.10531 11.2632 4.99995 10.998 4.99995H7.00001Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddGray);
export default __webpack_public_path__ + "static/media/ic_add_gray.55fa3299105de5386caac32a42efc729.svg";
export { ForwardRef as ReactComponent };